import React from "react";
import { sortTypes } from "../../../../utils/tableSortTypes";

const SortingIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
    >
      <g id="sorting_icon" transform="translate(-391 -318)">
        <path
          id="Polygon_24"
          data-name="Polygon 24"
          d="M4,0,8,6H0Z"
          transform="translate(391 318)"
          fill={fill === sortTypes.sortUp ? "#000" : "#b9b9b9"}
        />
        <path
          id="Polygon_25"
          data-name="Polygon 25"
          d="M4,0,8,6H0Z"
          transform="translate(399 332) rotate(180)"
          fill={fill === sortTypes.sortDown ? "#000" : "#b9b9b9"}
        />
      </g>
    </svg>
  );
};

export default SortingIcon;
